export default function createAndShowFlash(type: string, text: string): void {
  const flash = _createFlash(type, text)
  _showFlash(flash)
}

function _createFlash(type: string, text: string): HTMLElement {
  const flashHtml = `<div class="flashes--flash fade-in alert alert-${type}" role="alert">${text}</div>`
  return up.element.createFromHTML(flashHtml)
}

function _showFlash(flash: HTMLElement): void {
  const flashesContainer = document.querySelector('[up-id="flashes"]')!
  flashesContainer.appendChild(flash)
  up.hello(flash)
}
